export default "__VITE_ASSET__5abedb98__"